import React, { useEffect, useState } from "react";
import { Loader2, Printer, Calendar, Package } from "lucide-react";
import { api } from "../../api";
import { printLabels } from "./printLabels";

const today = () => new Date().toISOString().slice(0, 10);

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [day, setDay] = useState("");

  const load = (d) => {
    setLoading(true);
    const url = d ? `/admin/orders?day=${d}` : "/admin/orders";
    api.get(url).then((r) => setOrders(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(""); }, []);

  const revenue = orders.reduce((s, o) => s + (o.total || 0), 0);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div><h1 className="font-display text-3xl font-bold uppercase text-[#1B2a21]">Sales & Shipping Labels</h1><p className="text-[#6b7d72]">Filter by day and print shipping labels (name, address, date)</p></div>
        <div className="flex items-end gap-2">
          <div><label className="mb-1 block font-display text-xs font-semibold uppercase tracking-wider text-[#2D6A4F]">Day</label>
            <div className="flex items-center gap-2 rounded-xl border border-[#dceadf] bg-white px-3 py-2"><Calendar size={16} className="text-[#8aa093]" /><input type="date" value={day} onChange={(e) => setDay(e.target.value)} className="bg-transparent text-sm outline-none" /></div></div>
          <button onClick={() => load(day)} className="rounded-full bg-[#1B4332] px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white">Filter</button>
          <button onClick={() => { setDay(""); load(""); }} className="rounded-full border border-[#dceadf] bg-white px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-[#2D6A4F]">All</button>
        </div>
      </div>

      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-[#e6f0ea] bg-white p-4">
        <div className="flex gap-6">
          <div><p className="font-display text-2xl font-bold text-[#1B2a21]">{orders.length}</p><p className="text-sm text-[#6b7d72]">Orders {day ? `on ${day}` : "(all)"}</p></div>
          <div><p className="font-display text-2xl font-bold text-[#1B2a21]">£{revenue.toFixed(2)}</p><p className="text-sm text-[#6b7d72]">Revenue</p></div>
        </div>
        <button onClick={() => printLabels(orders, day)} disabled={!orders.length}
          className="flex items-center gap-2 rounded-full bg-[#2D6A4F] px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:bg-[#1B4332] disabled:opacity-50">
          <Printer size={18} /> Print Sales Labels
        </button>
      </div>

      {loading ? <Loader2 className="animate-spin text-[#2D6A4F]" /> : (
        <div className="overflow-x-auto rounded-2xl border border-[#e6f0ea] bg-white">
          <table className="w-full min-w-[720px] text-left text-sm">
            <thead className="bg-[#f0f7f2] font-display text-xs uppercase tracking-wider text-[#2D6A4F]"><tr><th className="p-4">Order</th><th className="p-4">Customer</th><th className="p-4">Destination</th><th className="p-4">Items</th><th className="p-4">Total</th><th className="p-4">Date</th></tr></thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.order_id} className="border-t border-[#f0f5f2]">
                  <td className="p-4 font-semibold text-[#1B4332]">{o.order_id}{o.is_subscription && <span className="ml-2 rounded-full bg-[#eaf4ee] px-2 py-0.5 text-[10px] font-bold uppercase text-[#2D6A4F]">Sub</span>}</td>
                  <td className="p-4">{o.customer?.name}<br /><span className="text-xs text-[#8aa093]">{o.customer?.email}</span></td>
                  <td className="p-4 text-[#6b7d72]">{o.customer?.city}, {o.customer?.country}</td>
                  <td className="p-4 text-[#6b7d72]">{(o.items || []).reduce((s, i) => s + i.qty, 0)}</td>
                  <td className="p-4 font-semibold text-[#1B4332]">£{Number(o.total).toFixed(2)}</td>
                  <td className="p-4 text-[#6b7d72]">{(o.created_at || "").slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!orders.length && <div className="p-10 text-center text-[#8aa093]"><Package className="mx-auto mb-2" /> No orders found.</div>}
        </div>
      )}
    </div>
  );
};

export default AdminOrders;
